/** @jsxImportSource @emotion/react */
import {css} from '@emotion/react';
import moment from 'moment';
import PropTypes from 'prop-types';
import {AdvancedFiltersProvider} from '../Shared/AdvancedFilters/AdvancedFiltersContext';
import DateRangeFilter from '../Shared/AdvancedFilters/Controls/DateRangeFilter';
import PosFilter from '../Shared/AdvancedFilters/Controls/PosFilter';
import BrandFilter from '../Shared/AdvancedFilters/Controls/BrandFilter';
import PlatformFilter from '../Shared/AdvancedFilters/Controls/PlatformFilter';
import OrderStatusFilter from '../Shared/AdvancedFilters/Controls/OrderStatusFilter';
import DisplayIdFilter from '../Shared/AdvancedFilters/Controls/DisplayIdFilter'
import { MultiPosFilter } from '../Shared/AdvancedFilters/Controls/MultiPosFilter'
import { IsScheduledFilter } from '../Shared/AdvancedFilters/Controls/IsScheduledFilter'


const AdvancedFilters = ({filters, onFiltersChange, debounceTimeInMs = 600, children, ...props}) => {
    return (
        <div className={props.className}>
            <div css={css`
              display: flex;
              flex-wrap: wrap;
              z-index: 999;
              position: relative;
            `}>
                <AdvancedFiltersProvider
                  filters={filters}
                  onFiltersChange={onFiltersChange}
                  debounceTimeInMs={debounceTimeInMs}
                >
                    {children}
                </AdvancedFiltersProvider>
            </div>
        </div>
    );
}

AdvancedFilters.propTypes = {
    filters: PropTypes.shape({
        dateRange: PropTypes.shape({
            startDate: PropTypes.instanceOf(moment),
            endDate: PropTypes.instanceOf(moment),
        }),
        displayId: PropTypes.arrayOf(PropTypes.string),
        isScheduled: PropTypes.bool,
        dateComparison: PropTypes.shape({
            startDate: PropTypes.instanceOf(moment),
            endDate: PropTypes.instanceOf(moment),
        }),
        merchantId: PropTypes.string,
        posIds: PropTypes.arrayOf(PropTypes.string),
        brandIds: PropTypes.arrayOf(PropTypes.string),
        platformIds: PropTypes.arrayOf(PropTypes.string),
        orderStatus: PropTypes.arrayOf(PropTypes.string),
    }).isRequired,
    onFiltersChange: PropTypes.func
}

AdvancedFilters.DateRangeFilter = DateRangeFilter;
AdvancedFilters.DisplayIdFilter = DisplayIdFilter;
AdvancedFilters.PosFilter = PosFilter;
AdvancedFilters.MultiPosFilter = MultiPosFilter;
AdvancedFilters.BrandFilter = BrandFilter;
AdvancedFilters.PlatformFilter = PlatformFilter;
AdvancedFilters.OrderStatusFilter = OrderStatusFilter;
AdvancedFilters.IsScheduledFilter = IsScheduledFilter;

export default AdvancedFilters;
